<template>

        <v-footer
        class="white--text text-center bg-red pt-10"
        >   
            <v-container>
                <v-row no-gutters>
                    <v-col cols="12" sm="4" class="mb-8 text-center text-sm-left" >
                        <img
                        alt="Kefuri"
                        class="shrink mt-1 mb-1 logo-b" 
                        contain
                        min-width="80"
                        src="../assets/logo-kefuri-w.png"
                        width="80"
                        >
                        <ul class="px-0 mt-6">
                            <li color="white"
                            class="mt-3">
                                <i class="mdi mdi-map-marker"></i>
                                Domeyko 2367, Santiago
                            </li>
                            <li color="white"
                            class="mt-3">
                                <i class="mdi mdi-phone"></i>
                                +56 229784084
                            </li>
                            <a href="mailto:contacto@kefuri.cl">
                                <li color="white" class="mt-3 white--text">
                                    <i class="mdi mdi-email"></i>
                                    contacto@kefuri.cl
                                </li>
                            </a>
                            <router-link class="link-menu" to="/Politica-privacidad">
                                    <li color="white" class="mt-3 white--text">
                                        Política de privacidad
                                    </li>
                            </router-link>
                            <router-link class="link-menu" to="/HowToDelete">
                                    <li color="white" class="mt-3 white--text">
                                        Como eliminar tu cuenta
                                    </li>
                            </router-link>
                        </ul>
                    </v-col>
                    
                    <v-col cols="12" sm="4">
                        <p class="text-center"><b>Sitios de interés</b></p>
                        <v-btn
                        v-for="(link, l) in links"
                        :key="l"
                        color="white"
                        text
                        rounded
                        :href="link.url"
                        target="_blank"
                        class="text-capitalize font-weight-regular d-block w-inherit"
                        >
                        {{ link.name }}
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="4" >
                        <v-btn
                        v-for="(redes, i) in icons"
                        :key="i"
                        class="mx-2 white--text"
                        icon
                        :href="redes.url"
                        target="_blank"
                        >
                        
                            <v-icon size="24px">
                            {{ redes.text }}
                            </v-icon>
                        
                        </v-btn>
                    </v-col>
                </v-row>
                <v-card-text class="white--text py-5">
                    <p>Algunos derechos reservados @{{ new Date().getFullYear() }} | <b>Kefuri</b> es un proyecto parte del <b>Web Intelligence Centre</b></p>
                </v-card-text>
            </v-container>
        </v-footer>

</template>

<script>
export default {
    name: 'Footer',
    props: [],
    data() {
        return {
            drawer: false,
            contact:[''],
            icons: [ 
                {text: 'mdi-facebook', url: 'https://www.facebook.com/kefuri.cl/'},
                {text: 'mdi-twitter', url: 'https://twitter.com/kefuri_cl?lang=es'},
                {text: 'mdi-linkedin', url: 'https://www.linkedin.com/in/francisca-gonzález-cohens-40a1b557/?originalSubdomain=cl'},
                {text: 'mdi-instagram', url: 'https://www.instagram.com/kefuri.cl/?hl=es-la'},
            ],
            
            links:[
                { name: 'Yo dono vida', url: 'https://yodonovida.minsal.cl/'},
                { name: 'Sociedad Chilena de Trasplantes', url: 'https://www.sociedaddetrasplante.cl/'},
                { name: 'Asoc. de Dializados y Trasplantados de Chile', url: 'https://asodi.cl/'},
                { name: 'Instituto de Salud Pública', url: 'http://www.ispch.cl/'},
                { name: 'Hospital del Salvador', url: 'https://www.hsalvador.cl/'},
                { name: 'Web Intelligence Centre', url: 'http://wic.uchile.cl/'},
            ]

        }
    }
}
</script>

<style scoped lang="sass">

ul
    list-style: none
</style>